import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "page d-overflow d-full d-flex-column" }
const _hoisted_2 = { class: "d-flex-1f" }
const _hoisted_3 = { class: "d-flex-1f d-overflow-not" }
const _hoisted_4 = { class: "d-flex-1f d-overflow-not" }
const _hoisted_5 = { class: "d-flex-1f d-overflow-not" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HelpWithLoveItem = _resolveComponent("HelpWithLoveItem")!
  const _component_app_list = _resolveComponent("app-list")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_interactiveOrActivity = _resolveComponent("interactiveOrActivity")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_ReasonDialog = _resolveComponent("ReasonDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_tabs, {
        "title-active-color": "#ff6d19",
        onRendered: _cache[0] || (_cache[0] = ($event: any) => (_ctx.rendered())),
        active: _ctx.active,
        "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.active) = $event)),
        animated: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_tab, { title: "我已帮助" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_app_list, {
                  onLoadData: _ctx.loadwobangzhubierenActivitiy,
                  ref: "appListRef"
                }, {
                  default: _withCtx(({ list }) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (item, index) => {
                      return (_openBlock(), _createBlock(_component_HelpWithLoveItem, {
                        "is-home-page": false,
                        item: item,
                        key: index,
                        ref_for: true,
                        ref: "helpWithLoveItem",
                        onOnHelpWithLoveItemResult: _ctx.onHelpWithLoveItemResult
                      }, null, 8, ["item", "onOnHelpWithLoveItemResult"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["onLoadData"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_tab, { title: "我的求助" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_app_list, {
                  onLoadData: _ctx.loadwodeqiuzhuActivitiy,
                  ref: "appListRef"
                }, {
                  default: _withCtx(({ list }) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (item, index) => {
                      return (_openBlock(), _createBlock(_component_HelpWithLoveItem, {
                        "is-home-page": false,
                        item: item,
                        key: index,
                        ref_for: true,
                        ref: "helpWithLoveItem",
                        onOnHelpWithLoveItemResult: _ctx.onHelpWithLoveItemResult
                      }, null, 8, ["item", "onOnHelpWithLoveItemResult"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["onLoadData"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_tab, { title: "我的发帖" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_app_list, {
                  onLoadData: _ctx.loadwodefatieActivitiy,
                  ref: "appListRef"
                }, {
                  default: _withCtx(({ list }) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (item, index) => {
                      return (_openBlock(), _createBlock(_component_interactiveOrActivity, {
                        "item-data": item,
                        key: index
                      }, null, 8, ["item-data"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["onLoadData"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["active"])
    ]),
    _createVNode(_component_ReasonDialog, {
      ref: "reasonDialog",
      onReasonDialogResult: _ctx.onReasonDialogResult
    }, null, 8, ["onReasonDialogResult"])
  ]))
}